import "preact/debug";
import clientFn from "./client.js";
var client_dev_default = clientFn;
export {
  client_dev_default as default
};
